// Finding states — D84 / 02 §3. Array order IS the classification ladder AND the display order:
// ❓ Непроверено → ❌ Липсва → ℹ️ По избор → 🔧 Счупено → ⚠️ Може по-добре → 💡 Подобрение → ✅ Има го
export const FINDING_STATES = [
    'unknown',
    'missing',
    'optional_missing',
    'broken',
    'subpar',
    'enhance',
    'ok',
];
/** Rank in the ladder; classification is strict top-down (D20/D84). */
export function stateRank(state) {
    return FINDING_STATES.indexOf(state);
}
/** States that represent a problem worth pitching (drives the card rollup strip, 04 §2). */
export const PROBLEM_STATES = [
    'missing',
    'broken',
    'subpar',
];
//# sourceMappingURL=states.js.map